import { useMemo } from 'react';
import { processAsJson } from '../utils/miscellaneous/processAsJson';

export const useNavigation = pushToHistory => {
    const navigationItem = sessionStorage.getItem('navigation');

    const { destination } = useMemo(
        () => navigationItem ? processAsJson(navigationItem) : {},
        [ navigationItem ]
    );

    if(destination) {
        sessionStorage.removeItem('navigation');
        pushToHistory(destination);
        return null;
    }
};